import GlobalEnum from "./enum";
import GlobalMethod from "./methods";
import GlobalRegExp from "./validate";
// import GlobalChart from './chart'

function install(Vue) {
  /* =====全局枚举===================================== */
  Vue.prototype.$enum = GlobalEnum;
  /* =====全局校验===================================== */
  Vue.prototype.$valid = GlobalRegExp;
  /* =====全局方法===================================== */
  for (const method in GlobalMethod) {
    Vue.prototype[method] = GlobalMethod[method];
  }
   /* =====枚举数组处理函数===================================== */
  Vue.prototype.$enumFactory = function(arr,key,value){
    let obj= {}
    arr.map(item=>{
      obj[item[key]] = item[value]
    })
    return obj
  }

  /* =====全局chart方法===================================== */
  // Vue.prototype.$chart = GlobalChart;
  /* =====全局过滤器=================================== */
  Vue.prototype.$filter = function(value, group) {
    if (
      Object.prototype.toString.call(value) != "[object Null]" &&
      Object.prototype.toString.call(value) != "[object Undefined]"
    ) {
      value = value.toString();
    }
    if (
      Object.prototype.toString.call(value) == "[object Null]" ||
      Object.prototype.toString.call(value) == "[object Undefined]" ||
      value.length == 0
    ) {
      return "--";
    }
    // let res = [];
    if (group) {
      // const key = `${group}`;
        let groupTemp = Object.entries(group);
        for (let i of groupTemp) {
          if (i[0] == value) {
            return i[1]
          }
        }
        return "--";
        // this.$store.state.enums[key] &&
        // this.$store.state.enums[key].filter(_ => _.value === value);
    } 
    // else {
    //   for (const key in this.$store.state.enums) {
    //     this.$store.state.enums[key].forEach(item => {
    //       if (item.value === value) {
    //         res = res.concat(this.$store.state.enums[key]);
    //       }
    //     });
    //   }
    //   res = res.filter(_ => _.value === value);
    // }
    // return res && res[0] ? res[0].text : value;
  };
}

export default { install };
